import { FieldTitle } from './RedStarTitle';
import Select from 'react-select';
import { toImgSrc } from './helpers';
import { Controller, useFormContext } from 'react-hook-form';
import { FieldDesc } from './common';
import { TextField } from '@client/new/components/basic';
import { PATHS } from '@client/routes';
import { Link } from 'react-router';
import { GetProgramPurchasePageByIdQuery } from 'generated/graphql';
import { ArrayItem } from '@client/new/helpers/types';

type RawWorkout = NonNullable<
  ArrayItem<NonNullable<GetProgramPurchasePageByIdQuery['program']['workouts']>>
>;
type Workout = Pick<RawWorkout, 'mediaCover' | 'mediaExercise' | 'name' | 'id'>;
export function WorkoutsSelect({
  index,
  workouts,
  influencerId,
}: {
  index: number;
  workouts?: Workout[] | null;
  influencerId: number;
}) {
  const { register, control, watch } = useFormContext();
  const r = (s) => register(`sections.${index}.${s}`);
  const state = watch(`sections.${index}`);

  const options = (workouts || []).map((workout) => ({
    value: workout.id,
    label: (
      <div className="flex items-center">
        <img
          src={toImgSrc(workout.mediaCover || workout.mediaExercise)}
          style={{
            maxHeight: '60px',
            borderRadius: '4px',
            marginRight: '10px',
          }}
        />
        {workout.name}
      </div>
    ),
  }));

  const selectedWorkouts = state.workoutIds?.length
    ? (workouts || []).filter((w) => (state.workoutIds || []).includes(w.id))
    : workouts || [];

  return (
    <div className="w-100">
      <div className="max-w-[680px]">
        <div>
          <FieldTitle title={'Headline text'} />
          <FieldDesc>
            The headline is used to communicate the creator’s value proposition
            in the hero section of the sales page.
          </FieldDesc>
          <TextField
            {...r(`title`)}
            className="mb-[5px] max-w-[680px] w-full"
            inputProps={{
              placeholder: 'Headline text',
              maxLength: 60,
            }}
          />
        </div>

        <div className="mt-8">
          <FieldTitle title={'Choose workouts'} optional />
          <FieldDesc>
            Will be displayed in order selected. By default 5 first workouts is
            displayed.
          </FieldDesc>
          <Controller
            name={`sections.${index}.workoutIds`}
            control={control}
            render={({ field: { value, onChange, ref } }) => (
              <Select
                ref={ref}
                isMulti
                options={options}
                value={options.filter((o) => (value || []).includes(o.value))}
                onChange={(options) => onChange(options.map((o) => o.value))}
                styles={{
                  control: (provided) => ({
                    ...provided,
                    minHeight: '56px',
                  }),
                }}
              />
            )}
          />
        </div>
      </div>

      <div className="mt-8">
        <div className="mb-4">Click to edit thumbnail:</div>
        <div className="flex flex-wrap space-y-2">
          {selectedWorkouts.map((w, i) => (
            <div
              key={w.id}
              style={{
                marginTop: i === 0 ? '8px' : '0px',
              }}
            >
              <Link
                to={PATHS.WORKOUT_EDIT({
                  influencerId,
                  workoutId: w.id,
                })}
                target="_blank"
              >
                <img
                  src={toImgSrc(w.mediaCover || w.mediaExercise)}
                  style={{
                    width: '100px',
                    height: '160px',
                    maxHeight: '200px',
                    borderRadius: '4px',
                    marginRight: '10px',
                    objectFit: 'cover',
                  }}
                />
              </Link>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
